import "./IconInfoCircle.scss";

export const IconInfoCircle = () => {
  return <span id="InfoCircleIconButton" className="icon-infoCircle"></span>;
};
